import { createSelector } from 'reselect';

// Config
import { getGiftingPaymentDetailsFailed } from '@redux/reducers/payment/paymentSelector';

const giftOptionsModalState = createSelector([getGiftingPaymentDetailsFailed], (getGiftingPaymentDetailsFailed) => ({
  getGiftingPaymentDetailsFailed,
}));

export default giftOptionsModalState;
